import { authConfig } from '../config';
import { auth0CoreStrategy } from './auth0/CoreStrategy';
import { cognitoCoreStrategy } from './cognito/CoreStrategy';

let coreStrategy = {
  getAccessToken: async () => null,
  getCurrentUserId: async () => null,
  hasActiveSession: async () => false,
};

let coreStrategyToUse = {};

switch (authConfig.provider) {
  case 'auth0':
    coreStrategyToUse = auth0CoreStrategy;
    break;
  case 'cognito':
  default:
    coreStrategyToUse = cognitoCoreStrategy;
    break;
}

Object.keys(coreStrategyToUse).forEach((key) => {
  coreStrategy[key] = coreStrategyToUse[key];
});

export { coreStrategy as AuthCoreStrategy };
